import { User, Mail, IdCard, Phone } from "lucide-react";
import { normalizeQuestionOptions } from "@/lib/checkout-form";

export const EMPTY_ARRAY: any[] = [];

/** Campos nativos do checkout (por ingresso) — sempre coletados; não dá pra remover/editar. */
export const NATIVE_ATTENDEE_FIELDS = [
  {
    id: "native-name",
    label: "Nome completo do participante",
    fieldTypeLabel: "Texto",
    icon: User,
    placeholder: "Como no documento",
  },
  {
    id: "native-email",
    label: "E-mail do participante",
    fieldTypeLabel: "E-mail",
    icon: Mail,
    placeholder: "email@exemplo.com",
  },
  {
    id: "native-cpf",
    label: "CPF do participante",
    fieldTypeLabel: "CPF",
    icon: IdCard,
    placeholder: "000.000.000-00",
  },
  {
    id: "native-phone",
    label: "Telefone do participante",
    fieldTypeLabel: "Telefone",
    icon: Phone,
    placeholder: "(11) 99999-9999",
  },
] as const;

export interface Props {
  eventId: string;
}

export type DraftState = {
  question: string;
  field_type: string;
  optionsText: string;
  is_required: boolean;
  applies_to: string;
  tier_ids: string[];
  is_validation_enabled?: boolean;
  validation_codes?: string;
};

export type TierPreview = {
  id: string;
  name: string;
  tier_type?: string | null;
  is_visible?: boolean | null;
  sort_order?: number | null;
};

export const emptyDraft = (): DraftState => ({
  question: "",
  field_type: "text",
  optionsText: "",
  is_required: false,
  applies_to: "order",
  tier_ids: [],
  is_validation_enabled: false,
  validation_codes: "",
});

export const normalizeTierIds = (value: string[] | null | undefined) => (value ?? []).filter(Boolean);

export const parseOptions = (options: any) => {
  if (typeof options === "string") {
    try { return JSON.parse(options); } catch { return options; }
  }
  return options;
};

export const buildDraftFromQuestion = (question: any): DraftState => {
  const opts = parseOptions(question?.options);
  return {
    question: question?.question ?? "",
    field_type: question?.field_type ?? "text",
    optionsText: Array.isArray(opts) ? normalizeQuestionOptions(opts ?? []).join("\n") : "",
    is_required: !!question?.is_required,
    applies_to: question?.applies_to ?? "order",
    tier_ids: normalizeTierIds(question?.tier_ids),
    is_validation_enabled: opts?.isValidationEnabled ?? false,
    validation_codes: Array.isArray(opts?.codes) ? opts.codes.join("\n") : "",
  };
};
